import { Divider, PageHeader } from '@hotjar/hotsauce';
import { useTranslation } from '@hotjar/translations';
import { useWindowTitle } from '@hotjar/webapp/hooks/useWindowTitle';
import { MfaBanner } from '@hotjar/webapp/features/Mfa/MfaBanner';
import { AccountDetailForm } from './AccountDetailForm/AccountDetailForm';
import { ExtremeMeasures } from './ExtremeMeasures/ExtremeMeasures';
import { SecurityDetail } from './SecurityDetail/SecurityDetail';
import { Page } from './styles';

export function ProfileDetails(): JSX.Element {
  const { t } = useTranslation('profile');
  useWindowTitle(t('account-detail.page-title'));

  return (
    <Page>
      <PageHeader title={t('account-detail.page-title')} />

      <MfaBanner />
      <AccountDetailForm />
      <Divider spacing="m" />
      <SecurityDetail />
      <Divider spacing="m" />
      <ExtremeMeasures />
    </Page>
  );
}
